import { cn } from "@tosize/ui";
import type { ComponentProps } from "react";

export function Divider({ className, ...props }: ComponentProps<"hr">) {
	return <hr className={cn("my-1.5 h-px w-full bg-shades text-shades", className)} {...props} />;
}

export function DividerSmall({ className, ...props }: ComponentProps<"hr">) {
	return (
		<span
			className={cn("w-full border-shades-medium-light border-b border-dashed", className)}
			{...props}
		/>
	);
}
